import axios from "axios";
import TokenService from "./token.service";

// You can use your own logic to set your local or production domain
const baseDomain = "https://si.stratis.pro";
const baseURL = `${baseDomain}/api/v1`;

const httpClient = axios.create({
  baseURL,
});

/**
 * Inteptor to inject Auth token into headers of each request
 * @param config
 * @return {*}
 */
const authInterceptor = (config) => {
  if (TokenService.hasAccessToken()) {
    config.headers.common['X-Authorization'] = TokenService.getAccessToken();
  }
  return config;
}

httpClient.interceptors.request.use(authInterceptor);

export default httpClient;



// WEBPACK FOOTER //
// ./src/services/httpClient.js